import { Component, OnInit, Input, Output, EventEmitter,ViewChild,ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LabeledProductService } from '../../services/labeledproduct.service';
import { LabeledProductShopStockService } from '../../services/labeledproductshopstock.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as JsBarcode from 'jsbarcode';
import { Observable } from 'rxjs/Observable';
import { ShopService } from '../../../configuration/services/shop.service';
import { PersonService } from '../../../person/services/person.service';



import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
@Component({
    selector: 'app-view-labeledproduct-edit-stock',
    templateUrl: './view-labeledproduct-edit-stock.component.html',
    styleUrls: ['./view-labeledproduct-edit-stock.component.css'],
    providers: [LabeledProductService,ShopService,PersonService,LabeledProductShopStockService]
  })

export class ViewLabeledProductEditStockComponent implements OnInit {
    id: number = undefined;
    productId: number = undefined;
    private sub: any;
    labeledProduct: any = {};
    shops:any = [];
    oldStock: number = 0;
    role:number = 3;
    photos:any = [];
    new_stock: any = 1;
    previousUpdate: boolean = false;
    nifForSearch:string;
    person:any = {};
    labeledProductShopsStock:any = [];
    transfer:any = {
        origin_shop:null,
        destination_shop: null,
        stock_to_move: 0
    };

    config: any = {'sourceField': ['number']};
    transferElements:any = [{number:'1'},{number:'2'},{number:'3'},{number:'4'},{number:'5'},{number:'6'},{number:'7'},{number:'8'},{number:'9'},{number:'10'}];
    
    
    constructor(private route: ActivatedRoute, private personService: PersonService, private labeledProductService:LabeledProductService, private router: Router,private shopService:ShopService,
         public toastr: ToastsManager,vcr: ViewContainerRef, public labeledProductShopStockService:LabeledProductShopStockService) {this.toastr.setRootViewContainerRef(vcr); }
    ngOnInit() {
        this.getShops().then(()=>{
            this.sub = this.route.params.subscribe(params => {
                this.route.queryParams.subscribe(queryParams => {
                    if (params['id'] !== undefined){
                        this.id = params['id'];
                        this.getLabeledProduct();
                    }
                });
            });
            try{
                this.role = JSON.parse(localStorage.getItem('user')).role;  
                this.transfer.origin_shop = parseInt(localStorage.getItem('transfer-origin-shop'));
                this.transfer.destination_shop = parseInt(localStorage.getItem('transfer-destination-shop'));
            }catch(e){
            }
        });
    }
    ngOnDestroy() {
      this.sub.unsubscribe();
    }


    getShops(){
        return new Promise((resolve, reject) => {
            this.shopService.query({})
            .subscribe((shops) => {
                this.shops = shops;
                resolve();
            });
        });
    }

    search(nif){
        let params={
          nif: nif
        }
        this.personService.query(params)
        .subscribe((people) => {
            var person = people[0];
            if (person)
                this.person = person;
        });
      }

    getLabeledProduct(){
        this.labeledProductService.get(this.id).subscribe((labeledProduct) => {
            this.labeledProduct = labeledProduct;
            this.person = this.labeledProduct.person;
            this.labeledProduct.shop_id = labeledProduct.shop? labeledProduct.shop.id:null;
            this.oldStock = labeledProduct.stock;
            this.getStockByShop(this.labeledProduct.id);
            this.getProductPhotos(labeledProduct);
            if (this.labeledProduct.barcode){
                setTimeout( ()=>{
                    JsBarcode("#barcode",this.labeledProduct.barcode,{format: "CODE128",width:7,fontSize: 50,textMargin:-12,margin:0, height: 70});
                    this.labeledProduct.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
                },0);
            } 
        });
    }

    getLabeledProducts(barcode){
        var params = {
            where: {barcode:{contains:barcode}},
            sort: 'id DESC',
            limit: 1
        };
        this.labeledProductService.query(params)
            .subscribe((labeledProducts) => {
                this.labeledProduct = labeledProducts[0];
                this.getStockByShop(this.labeledProduct.id);
            });
    }

    getStockByShop(id){
        let params = {
            labeledproduct: id
        }
        this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStock) => {
            this.labeledProductShopsStock = labeledProductShopStock;
        });
    }

    getProductPhotos(labeledProduct){
        this.labeledProductService.getProductPhotos(labeledProduct.id)
        .subscribe((result) => {
            this.photos = result;
        })
    }

    updateLabeledProductWithConfirm(printTag, redirect){
        if (!this.previousUpdate){
            this.previousUpdate = true;
            this.updateLabeledProduct(printTag, redirect);
        }else{
            var r = confirm("Acabas de actualizar este producto ¿Deseeas actualizarlo de nuevo?");
            if (r == true) {
                this.updateLabeledProduct(printTag, redirect);
            }
        }
    }

    updateLabeledProduct(printTag, redirect){
        if (this.new_stock > 0 || this.role == 1){
            let currentElementStock = this.labeledProductShopsStock.filter((e)=> {return e.shop.id === this.labeledProduct.shop_id && e.labeledproduct.id === this.labeledProduct.id})
            let currentStock = currentElementStock[0]? currentElementStock[0].stock:0
            var stock = currentStock +  parseInt(this.new_stock);     
            if (currentElementStock[0]){
                this.labeledProductShopStockService.update({id:currentElementStock[0].id, stock:stock}).subscribe(() =>{
                    this.new_stock=0;
                    this.getLabeledProduct();
                    if (printTag){
                        this.printTags();
                    }else{
                        this.toastr.success('', 'Stock actualizado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    }
                    if (redirect){
                        this.router.navigate(["/labeledproduct/listtoeditstock"]);
                    }
                });
            }else{
                this.labeledProductShopStockService.create({stock:stock, labeledproduct: this.labeledProduct.id,shop: this.labeledProduct.shop_id}).subscribe(() =>{
                    this.new_stock=0;
                    this.getLabeledProduct();
                    if (printTag){
                        this.printTags();
                    }else{
                        this.toastr.success('', 'Stock actualizado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    }
                    if (redirect){
                        this.router.navigate(["/labeledproduct/listtoeditstock"]);
                    }
                });
            }
        }else{
            this.toastr.error('', 'No puedes poner un stock inferior al actual', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
        }
    }

    printTags(){
        document.getElementById("ticket").classList.remove('hide')
        window.print();
        document.getElementById("ticket").classList.add('hide')
    }

    transferStock(){
        localStorage.setItem('transfer-origin-shop', this.transfer.origin_shop);
        localStorage.setItem('transfer-destination-shop', this.transfer.destination_shop);
        this.transfer.stock_to_move = parseInt(this.transfer.stock_to_move);
        if (this.transfer.stock_to_move > 0 && this.transfer.origin_shop && this.transfer.destination_shop && this.transfer.origin_shop != this.transfer.destination_shop){
            let originLabeledProductStock = this.labeledProductShopsStock.filter((e)=> {return e.shop.id === this.transfer.origin_shop && e.labeledproduct.id === this.labeledProduct.id})
            let destinationLabeledProductStock = this.labeledProductShopsStock.filter((e)=> {return e.shop.id === this.transfer.destination_shop && e.labeledproduct.id === this.labeledProduct.id})
            if (originLabeledProductStock[0] && originLabeledProductStock[0].stock && originLabeledProductStock[0].stock >= this.transfer.stock_to_move){
                this.updateStockByShop(originLabeledProductStock[0], parseInt(originLabeledProductStock[0].stock)-this.transfer.stock_to_move,this.transfer.origin_shop).then(()=>{
                    this.updateStockByShop(destinationLabeledProductStock[0], destinationLabeledProductStock[0] && destinationLabeledProductStock[0].stock?parseInt(destinationLabeledProductStock[0].stock)+this.transfer.stock_to_move:this.transfer.stock_to_move,this.transfer.destination_shop).then(()=>{
                        this.getLabeledProduct();
                        this.toastr.success('', 'Stock actualizado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    });
                });
            }else{
                this.toastr.error('', 'No puedes hacer el trasvase, ya que no hay suficientes productos en la tienda de origen', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            }
        }else{
            this.toastr.error('', 'No definido el número de productos a mover o las tiendas de origen y destino', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
        }
    }

    updateStockByShop(currentStockObject, newStock, shop_id){
        return new Promise((resolve, reject) => {
            if (currentStockObject){
                this.labeledProductShopStockService.update({id:currentStockObject.id, stock:newStock}).subscribe(() =>{
                    resolve();
                });
            }else{
                this.labeledProductShopStockService.create({stock:newStock, labeledproduct: this.labeledProduct.id,shop: shop_id}).subscribe(() =>{
                    resolve();
                });
            }
        })
    }


  stockToMoveSelected(e){
    this.transfer.stock_to_move = e.number
  }


}


// WEBPACK FOOTER //
// ./src/app/labeledproducts/components/view-labeledproduct-edit-stock/view-labeledproduct-edit-stock.component.ts